<template>
  <!-- 関連事件編集 -->
  <ModalDialog
    pop-name="関連事件編集"
    dialog-height="auto"
    dialog-width="600px"
    margin-class="mtp-3 mbm-3"
    @close="closeModal"
  >
    <template #header> </template>
    <template #body>
      <div class="mtp-3">
        <div
          v-for="(item, index) in eventList"
          :key="index"
          style="text-align: center; justify-content: center"
        >
          <div v-if="item.islink" class="d-flex align-items-center">
            <div class="d-flex">
              <input class="form-check-input me-2" type="checkbox" />
              <b>
                <router-link to="" class="link">{{ item.title }}</router-link>
              </b>
            </div>
            <ButtonMain class="ms-3" button-name="検索" @click="search">
            </ButtonMain>
          </div>
          <div v-else>
            <div class="d-flex mtp-1">
              <input class="form-check-input me-2" type="checkbox" />
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div style="text-align: center">
        <ButtonMain
          button-name="登録"
          style="margin-right: 15px"
          @click="closeModal"
        ></ButtonMain>
        <ButtonDelete button-name="削除" @click="closeModal"></ButtonDelete>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'IncidentsCompilationDialog',
  props: {
    Events: Array
  },
  data() {
    return {
      eventList: [],
      searchShow: false
    }
  },
  mounted() {
    this.eventList = this.Events
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    search() {
      this.$emit('search')
    }
  }
}
</script>
<style scoped lang="scss"></style>
